import { Component } from 'react'
import { Avatar } from '@driftt/tide-core-legacy'

class AgentStatusAvatar extends Component {
  render() {   
    return (
      <div className="drift-status-nav-icon" onClick={this.props.onClick}>
        <div className="agent-status-avatar">
          <Avatar
            withPresence={true}
            presenceState={this.props.agentStatus}
            withBorder={true}
            user={this.props.currentUser} />
        </div>
      </div>
    )
  }
}

export default AgentStatusAvatar



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/NewAgentStatus/AgentStatusAvatar/component.js